export default {
  translation: {
    appName: 'PetPro Owner Cockpit',
    brand: 'PetPro',
    loading: 'Loading…',

    range: {
      label: 'Range',
      last7: 'Last 7 days',
      last30: 'Last 30 days',
      last90: 'Last 90 days',
    },

    stats: {
      occupancy: 'Occupancy',
      revenue: 'Revenue paid',
      grossRevenue: 'Gross booked',
      bookings: 'Bookings',
      avgPerNight: 'avg / night',
      thisRange: 'this range',
    },

    lost: {
      headline: 'You left {{amount}} on the table',
      detail: '{{nights}} empty kennel-nights at NT${{rate}} avg / night.',
      hint: '(Phase 5C: one click → midweek win-back campaign)',
      label: 'Revenue left on the table',
      subPattern: '{{empty}} empty / {{total}} kennel-nights',
    },

    occupancy: {
      title: 'Occupancy heatmap',
      empty: 'No occupancy data for this range.',
      legendEmpty: 'empty',
      legendFull: 'full',
    },

    revenue: {
      title: 'Revenue by service',
      empty: 'No revenue in this range.',
      boarding: 'Boarding',
      daycare: 'Daycare',
      grooming: 'Grooming',
      paid: 'paid',
      gross: 'gross',
      count: 'bookings',
    },

    channel: {
      title: 'Where bookings come from',
      empty: 'No bookings in this range.',
      own_site: 'Own site',
      line: 'LINE',
      google: 'Google',
      cherie: 'Cherie',
      staff: 'Staff',
      phone: 'Phone',
      unknown: 'Other',
    },

    richMenu: {
      title: 'LINE menu',
      sub: 'The tappable menu pinned at the bottom of your LINE chat. Auto-generate one from your branding, or upload your own design.',
      notConnected: 'Connect your LINE Official Account first (Settings → LINE) to use a rich menu.',
      statusProvisioned: 'Menu live since {{when}}',
      statusMode_generated: 'auto-generated',
      statusMode_custom: 'custom design',
      statusNone: 'No menu provisioned yet.',
      brandingHint: 'Changed your logo or brand color? Re-apply the menu so LINE shows the new look.',
      modeGenerated: 'Auto-generated',
      modeGeneratedHint: 'Drawn from your logo + brand color. Zero design work.',
      modeCustom: 'Custom design',
      modeCustomHint: 'Your designer\'s artwork, drawn under our template. Full visual control.',
      apply: 'Apply menu',
      reapply: 'Re-apply menu',
      applying: 'Applying…',
      remove: 'Remove menu',
      layout: 'Layout',
      template: 'Download template',
      templateHint: 'Give this to your designer — artwork must match it exactly ({{w}}×{{h}}px, PNG/JPEG, ≤1MB).',
      upload: 'Upload artwork',
      uploading: 'Uploading…',
      replace: 'Replace artwork',
      zoneActions: 'Tap actions',
      zone: 'Zone {{n}}',
      actionPortal: 'Portal page',
      actionChat: 'Open chat',
      actionUrl: 'External link',
      tab_status: 'Pet status',
      tab_report: 'Daily report',
      tab_contact: 'Contact staff (chat)',
      tab_reservations: 'Next stay',
      tab_book: 'Book again',
      tab_info: 'Facility info',
      urlPlaceholder: 'https://…',
      chatBar: 'Chat bar label',
      chatBarHint: 'Text on the collapsed menu bar (max 14 characters).',
      saveConfig: 'Save design',
      saved: 'Design saved.',
      applyCustom: 'Save & apply menu',
      needImage: 'Upload your artwork first.',
      wrongSize: 'Image must be exactly {{w}}×{{h}}px for this layout (got {{gw}}×{{gh}}px).',
      tooBig: 'Image is over 1MB — LINE rejects it. Re-export at lower quality.',
      applied: 'Menu applied — check your LINE chat.',
      removed: 'Menu removed.',
      revert: 'Revert to auto-generated',
      previewHint: 'Overlay shows tap zones. Taps go to the action set on each zone.',
    },
    bookingPage: {
      title: 'Public booking page',
      sub: 'Your business on Google + a real booking page anyone can find.',
      stateLive: 'Live at',
      stateNoSlug: 'Pick a URL to publish your booking page.',
      stateDisabled: 'Booking page is currently OFFLINE — turn it on to start receiving bookings.',
      stateReady: 'Ready to publish — flip the switch to go live.',
      slugLabel: 'Page URL',
      slugHint: 'Lowercase Latin or CJK characters, digits, and hyphens. Pick something short and memorable.',
      slugPlaceholder: 'e.g. furkid-home or 毛孩之家',
      slugTaken: 'This URL is already taken. Try another.',
      slugFormat: 'Must be 2–40 characters; lowercase Latin or CJK, digits, hyphens. Can\'t start or end with a hyphen.',
      enabled: 'Public booking page',
      enabledHint: 'When on, anyone can find and book on your page.',
      englishEnabled: 'Publish English variant too',
      // SHARED-1 feature toggles
      featuresHeading: 'Features',
      addOnsEnabled: 'Booking add-ons',
      addOnsHint:
        'Let customers tick add-ons (nail trim, take-home shampoo, etc.) on the booking review step. Paid at facility on completion.',
      photoCardsEnabled: 'Photo memory cards',
      photoCardsHint:
        'Staff can send a branded before/after photo card to the customer via LINE after a visit. Requires opt-in per booking.',
      taxInclusive: 'Prices are tax-inclusive (TW B2C)',
      taxInclusiveHint:
        'When ON, the prices you type include 5% VAT (typical for TW consumer business). When OFF, 5% VAT is added at invoice time.',
      requireDeposit: 'Require a deposit to book',
      requireDepositHint:
        'When ON, online bookings are held as pending and auto-confirm once the deposit is paid. The strongest no-show control.',
      depositPercent: 'Deposit percentage',
      depositPercentHint: 'Calculated from the estimated total. E.g. 30% of NT$2,000 = NT$600.',
      depositGatewayReady: '✓ Online payments connected (ECPay) — customers can pay the deposit during booking.',
      depositLink: 'Payment link (no online gateway yet)',
      depositLinkHint:
        'Online card payments are not set up yet — paste your own payment link (LINE Pay / bank transfer details) and we will send it to the customer after booking.',
      englishHint: 'Adds /<slug>/en as an English alternate (for Google + international visitors).',
      displayNameZh: 'Business name (中文)',
      displayName: 'Business name (English, optional)',
      taglineZh: 'Tagline (中文)',
      tagline: 'Tagline (English, optional)',
      save: 'Save changes',
      saving: 'Saving…',
      saved: 'Saved',
      visit: 'Visit',
      copy: 'Copy URL',
      copied: 'Copied!',
      // Phase 6A.5 — identity pack
      identityHeading: 'Your business identity',
      identitySub: "Add a logo, photos, and a video so your booking page looks like you, not us.",
      logo: 'Logo',
      logoHint: 'Square works best. PNG / JPG / WebP, up to 8 MB.',
      logoAlt: 'Business logo',
      accentColor: 'Brand color',
      accentColorHint: 'Used for headings and buttons on your booking page.',
      gallery: 'Photo gallery',
      galleryHint: 'Up to 8 photos. The first one becomes your hero image.',
      addPhoto: 'Add photos',
      removePhoto: 'Remove',
      uploading: 'Uploading…',
      uploadFailed: 'Upload failed. Try again.',
      uploadTooLarge: 'File is over 8 MB — please choose a smaller image.',
      uploadBadType: "We only accept JPG, PNG, WebP, or GIF.",
      video: 'Intro video',
      videoHint: 'Paste a YouTube or Vimeo link. We\'ll embed it on your booking page.',
      videoPlaceholder: 'https://youtube.com/watch?v=…',
      videoClear: 'Remove video',
    },

    marketing: {
      title: 'Marketing — ready to send',
      subtitle: 'One-click LINE campaigns against the segments you already have.',
      empty: 'No reachable owners yet. Connect LINE to start.',
      lapsedTitle: 'Win back lapsed owners',
      lapsedHook: '{{count}} owners haven\'t booked in 60+ days.',
      lapsedCta: 'Send LINE win-back',
      seasonalTitle: 'Seasonal push',
      seasonalHook: '{{count}} active owners — ready for a holiday/seasonal message.',
      seasonalCta: 'Compose seasonal',
      comingSoon: 'Composer coming soon',
      confirmTitle: 'Send LINE win-back campaign',
      confirmRecipients: '{{count}} owners will receive this message.',
      confirmMessageLabel: 'Message',
      confirmSampleLabel: 'Sample owners',
      cancel: 'Cancel',
      send: 'Send now',
      sending: 'Sending…',
      sentToast: 'Sent to {{count}} owners',
      defaultMessage:
        'Hi {{ownerName}}! It\'s been a while — we\'d love to host {{petName}} again. ' +
        'Here\'s 10% off your next booking through the end of the month.',
    },

    assistant: {
      fab: 'Ask',
      title: 'Owner-growth assistant',
      sub: 'Read-only · grounded in your live data',
      placeholder: 'Ask about occupancy, revenue, channels, or lapsed customers…',
      send: 'Send',
      thinking: 'Thinking…',
      emptyHint: 'Try:',
      suggestions: [
        'Where do my bookings come from?',
        'Who lapsed in the last 60 days?',
        'How much revenue did I leave on the table?',
      ],
      toolsUsed: 'Read {{count}} tool(s)',
      close: 'Close',
    },

    auth: {
      mock: 'Mock data',
      logout: 'Sign out',
      loginTitle: 'Sign in to PetPro Owner Cockpit',
      loginSubtitle: 'Choose how to sign in.',
      tokenLabel: 'Access token (JWT)',
      tokenHint: 'Your token comes from PetPro support during onboarding.',
      enter: 'Open cockpit',
      // Phase 6B — primary login paths
      continueWithLine: 'Continue with LINE',
      signInWithEmail: 'Sign in with email',
      firstTimeHint: 'First time? Use LINE and have the 6-digit activation code from PetPro ready.',
      advancedJwt: 'Advanced: sign in with an access token',
      advancedJwtHint: 'This entry point is for PetPro support and internal testing only. Merchants should use LINE or email above.',
      // /login/email
      email: {
        title: 'Sign in with email',
        sub: "We'll email you a one-time sign-in link.",
        sentSub: 'Email sent to {{email}}.',
        label: 'Business email',
        send: 'Email me a link',
        inboxHint: 'Check your inbox (including spam). The link is valid for 15 minutes and can only be used once.',
        sameBrowserHint: 'For your security, open the link in the same browser you requested it from.',
        resend: 'Resend',
        resendIn: 'Resend in {{seconds}}s',
        firstTimeHint: "Not getting the email? First-time merchants should use LINE + activation code.",
        back: 'Back to sign in',
      },
      // /login/claim
      claim: {
        title: 'Activate your business account',
        welcomeNamed: 'Hi {{name}}!',
        welcomeAnon: 'Welcome to PetPro Owner Cockpit.',
        noEmail: '(no email shared by LINE)',
        codeLabel: '6-digit activation code',
        codeHint: 'PetPro support hands this out at onboarding (CCxxxx is a support-side label, not the code).',
        submit: 'Activate + open cockpit',
        noCodeHint: "Don't have a code? Contact PetPro support.",
        formatError: 'Enter 6 digits.',
      },
      // Callback waiting
      callback: {
        signingIn: 'Signing you in…',
      },
      // Error reasons surfaced via ?error=… on the login URL.
      error: {
        generic: 'Sign-in failed. Please try again.',
        state: 'Sign-in expired. Please start again.',
        channel: 'LINE sign-in is temporarily unavailable. Try email instead.',
        exchange: 'LINE verification failed. Please try again.',
        browser_mismatch: 'Open this link in the same browser you requested it from.',
        expired: 'This sign-in link has expired. Request a new one.',
        used: 'This sign-in link has already been used. Request a new one.',
        invalid: 'Invalid sign-in link.',
      },
    },

    errors: {
      generic: 'Something went wrong. Please try again.',
      network: 'Network error. Check your connection and retry.',
      unauthorized: "Your session expired. Please sign in again.",
    },

    policies: {
      title: 'AI Concierge · Shop Policies / FAQ',
      subtitle: 'The LINE concierge answers policy questions ONLY from these entries; with no matching entry it hands off to staff instead of guessing.',
      questionLabel: 'Question customers ask',
      questionPlaceholder: 'e.g. Can I bring my own food?',
      answerLabel: 'Your answer',
      answerPlaceholder: 'e.g. Yes! Please include feeding instructions at check-in.',
      addButton: 'Add entry',
      added: 'Added',
      empty: 'No entries yet. Add a few FAQs and the concierge can answer for you!',
      loadFailed: "Couldn't load entries",
      saveFailed: 'Save failed — please retry',
      deleteConfirm: 'Delete this entry?',
      activeToggle: 'Active',
      delete: 'Delete',
    },

    packages: {
      // Phase A1a — cockpit Packages tab (read-only catalog)
      navLink: 'Packages',
      title: 'Service packages',
      back: 'Back to cockpit',
      loading: 'Loading packages…',
      editingComingSoon: 'Editing arrives in the next release — view-only for now.',
      offerings: {
        title: 'Offerings',
        subtitle: 'Prepaid credit packs your customers can buy: grooming, daycare, or boarding sessions.',
        cardTitle: 'Your packages',
        count_one: '{{count}} active package · {{archived}} archived',
        count_other: '{{count}} active packages · {{archived}} archived',
        countSimple_one: '{{count}} package',
        countSimple_other: '{{count}} packages',
      },
      filter: {
        allServices: 'All service types',
        includeArchived: 'Include archived',
      },
      serviceType: {
        boarding: 'Boarding',
        daycare: 'Daycare',
        grooming: 'Grooming',
      },
      card: {
        defaultPrice: 'Default price',
        validity: 'Validity',
        validityValue: '{{days}} days',
        refund: 'Refunds',
        transferability: 'Transferability',
        archived: 'Archived — not visible to customers',
      },
      refundPolicy: {
        none: 'Non-refundable',
        prorated: 'Pro-rated (unused sessions)',
        prorated_with_fee: 'Pro-rated minus early-termination fee',
        full_within_window: 'Full refund within window',
      },
      transferability: {
        household: 'Family pack (all pets in household)',
        owner_only: 'Pet-specific',
      },
      empty: {
        title: 'No packages yet',
        subtitle: 'Create your first prepaid pack to lock in customer revenue.',
        comingSoon: 'Editor coming soon — packages can be seeded by support for now.',
      },
      errors: {
        loadFailed: 'Could not load packages. Please try again.',
      },
      dashboardTile: {
        label: 'Packages sold',
        expiringWithin7d_one: '{{count}} expiring in 7d',
        expiringWithin7d_other: '{{count}} expiring in 7d',
      },
      redemptions: {
        title: 'Redemptions',
        includeVoided: 'Include voided',
        einvoiceWarning:
          'Camus has issued the e-invoice for each redemption — do NOT issue a second 統一發票.',
        empty: 'No redemptions yet.',
        colWhen: 'When',
        colService: 'Service',
        colKind: 'Kind',
        colSessions: 'Sessions',
        colActions: 'Actions',
        kindRedeem: 'Redeem',
        kindRestore: 'Restore',
        kindVoided: 'Voided',
        undoBtn: 'Undo',
        restoreBtn: 'Restore credit',
        undoReasonPrompt: 'Reason for undo (audit log):',
        errors: {
          ERROR_PACKAGES_VOID_WINDOW_EXPIRED:
            'Past the 24h Undo window — use Restore Credit instead.',
          load_failed: 'Could not load redemptions.',
          void_failed: 'Undo failed.',
        },
      },
      restore: {
        title: 'Restore session credit',
        subtitle:
          'For early checkouts past the 24h Undo window. The original redemption stays in the log; a compensating "restore" row credits unconsumed sessions back.',
        original: 'Original sessions consumed',
        sessionsUsedSuffix: 'sessions',
        serviceType: 'Service',
        sessionsToRestore: 'Sessions to restore',
        sessionsHelp: 'Up to {{max}}; will appear as a positive +N row.',
        reasonLabel: 'Reason (audit log)',
        reasonPlaceholder: 'e.g. customer picked up dog one night early',
        cancel: 'Cancel',
        confirm: 'Restore credit',
        errors: {
          sessions_must_be_positive: 'Must restore at least 1 session.',
          sessions_exceed_consumed: 'Cannot restore more than was consumed.',
          reason_required: 'Reason is required for the audit log.',
          ERROR_PACKAGES_RESTORE_EXCEEDS_CONSUMED:
            'Cannot restore more than was originally consumed.',
          restore_failed: 'Restore failed.',
        },
      },
      priceChange: {
        impactTitle: 'Heads-up: this change has blast radius',
        activeOnOldPrice_one: '{{count}} customer holds a pack at this price',
        activeOnOldPrice_other: '{{count}} customers hold packs at this price',
        pendingCheckouts_one: '{{count}} checkout is in flight',
        pendingCheckouts_other: '{{count}} checkouts are in flight',
        oldPriceHonored:
          'Existing customers keep the old price (snapshot pattern).',
        lastSale: 'Last sale {{days}}d ago',
        noSales: 'No sales yet on this tier.',
      },
      addOns: {
        title: 'Add-ons',
        subtitle:
          'Per-item upsells the customer can tick at booking — nail trim, take-home shampoo, late checkout, etc. Paid at facility on completion.',
        empty: 'No add-ons yet.',
        emptyCta: 'Create your first add-on',
        addBtn: 'New add-on',
        colName: 'Name',
        colPrice: 'Price',
        colCategory: 'Category',
        colApplicableTo: 'Applies to',
        colStatus: 'Status',
        colActions: 'Actions',
        statusActive: 'Active',
        statusInactive: 'Inactive',
        editBtn: 'Edit',
        deleteBtn: 'Delete',
        deleteConfirm: 'Delete this add-on? Past bookings keep the snapshot.',
        loading: 'Loading add-ons…',
        loadFailed: 'Could not load add-ons.',
        category: {
          grooming: 'Grooming',
          wellness: 'Wellness',
          retail: 'Retail',
          other: 'Other',
        },
        service: {
          boarding: 'Boarding',
          daycare: 'Daycare',
          grooming: 'Grooming',
        },
        editor: {
          createTitle: 'New add-on',
          editTitle: 'Edit add-on',
          nameLabel: 'Name (English)',
          nameZhLabel: 'Name (中文) — shown to customers',
          categoryLabel: 'Category',
          priceLabel: 'Price (NT$, tax-inclusive)',
          pricingTypeLabel: 'Pricing',
          pricingType: {
            per_session: 'Per session',
            per_night: 'Per night',
            one_time: 'One-time',
          },
          durationLabel: 'Duration (min, optional)',
          applicableLabel: 'Applies to service types',
          notesLabel: 'Internal notes (optional)',
          retailInventoryHint:
            'v1 does not track inventory — toggle Active off when sold out.',
          activeLabel: 'Active',
          cancel: 'Cancel',
          save: 'Save',
          required: 'Required',
          priceMustBePositive: 'Price must be > 0',
          mustPickAtLeastOneService:
            'Pick at least one service this add-on applies to.',
        },
      },
      outstanding: {
        title: 'Outstanding',
        summary_one: '{{count}} pack expiring in <14 days · total face value {{total}}',
        summary_other: '{{count}} packs expiring in <14 days · total face value {{total}}',
        statusAll: 'All statuses',
        statusActive: 'Active',
        statusExhausted: 'Exhausted',
        statusRefunded: 'Refunded',
        expiringBanner_one: '{{count}} pack expires in the next 14 days. Consider nudging the customer.',
        expiringBanner_other: '{{count}} packs expire in the next 14 days. Consider nudging customers.',
        empty: 'No purchases yet.',
        colPackage: 'Package',
        colRemaining: 'Remaining',
        colPaid: 'Paid',
        colExpires: 'Expires',
        colStatus: 'Status',
        colActions: 'Actions',
        refundedAmount: '−{{amount}} refunded',
        daysLeft_one: '{{days}}d',
        daysLeft_other: '{{days}}d',
        refundBtn: 'Refund',
        status_active: 'Active',
        status_exhausted: 'Exhausted',
        status_expired: 'Expired',
        status_refunded: 'Refunded',
        status_cancelled: 'Cancelled',
        status_disputed: 'Disputed',
      },
      refund: {
        title: 'Refund package purchase',
        previewFailed: 'Could not compute refund preview.',
        formula: 'Refund calculation',
        paid: 'Paid',
        fee: 'Stripe fee',
        consumed: '{{sessions}} sessions × {{unit}}',
        alreadyRefunded: 'Already refunded',
        allowed: 'Allowed refund',
        amountLabel: 'Refund amount ({{currency}}, cents)',
        reasonLabel: 'Reason (required, audit log)',
        reasonPlaceholder: 'e.g. customer moved out of area',
        cancel: 'Cancel',
        confirm: 'Confirm refund',
        errors: {
          amount_must_be_positive: 'Amount must be positive.',
          amount_exceeds_allowed: 'Amount exceeds the policy-allowed cap.',
          reason_required: 'Reason is required for the audit log.',
          packages_purchase_disputed: 'Purchase is under dispute — refund via Stripe directly.',
          packages_already_refunded: 'Purchase is already fully refunded.',
          refund_failed: 'Refund failed. Please try again.',
        },
      },
      editor: {
        titleCreate: 'New service package',
        titleEdit: 'Edit service package',
        subtitle: 'Define a prepaid pack and its tier ladder. Customers pay once; sessions deduct on each booking.',
        tierPreview: 'Tier preview:',
        newPackage: 'New package',
        editButton: 'Edit',
        archiveButton: 'Archive',
        restoreButton: 'Restore',
        serviceType: 'Service type',
        serviceTypeLocked: 'Service type is locked once customers have bought this package.',
        nameEn: 'Name (English)',
        nameZh: 'Name (中文)',
        descEn: 'Description (English)',
        descZh: 'Description (中文)',
        basePriceMinor: 'Base price (cents)',
        basePriceHint: 'In smallest currency unit. NT$4,500 = 450000.',
        validityDays: 'Validity (days)',
        transferability: 'Transferability',
        einvoiceRequired: 'Require e-invoice info at checkout (統一發票)',
        refundMode: 'Refund policy',
        refundWindowDays: 'Refund window (days)',
        refundFeeMinor: 'Early termination fee (cents)',
        article19Warning:
          'Non-refundable packs may be challenged under Taiwan Consumer Protection Act Article 19 (7-day return on remote sales). Make sure your terms are visible at checkout.',
        tierLadder: 'Tier ladder',
        tierLadderHint:
          'Strictly ascending paid sessions. Pick one default tier (radio).',
        defaultTier: 'Default tier',
        paidSessions: 'Paid',
        bonusSessions: 'Bonus',
        priceMinor: 'Price (cents)',
        unitCost: 'NT${{unit}} per session × {{total}} sessions',
        addTier: 'Add tier',
        removeTier: 'Remove tier',
        cancel: 'Cancel',
        saveNew: 'Create package',
        saveExisting: 'Save changes',
        errors: {
          name_required: 'Both English and 中文 names are required.',
          price_negative: 'Base price cannot be negative.',
          tiers_required: 'At least one tier is required.',
          tier_paid_min: 'Paid sessions must be at least 1.',
          tier_ascending: 'Paid sessions must be strictly ascending.',
          tier_price_negative: 'Tier price cannot be negative.',
          package_name_duplicate: 'A package with this English name already exists.',
          package_tiers_max_exceeded: 'Maximum 6 tiers per package.',
        },
      },
    },

    billing: {
      banner: {
        past_due: 'Payment is overdue — service continues for now',
        canceled: 'Subscription inactive — read-only mode',
        suspended: 'Subscription suspended — pay to restore access',
        graceLeft: '{{days}} grace days remaining',
        payNow: 'Pay now',
        dismiss: 'Dismiss',
      },
      state: {
        active: 'Active',
        trialing: 'Trial',
        comped: 'Sponsored',
        past_due: 'Past due',
        canceled: 'Inactive (read-only)',
        suspended: 'Suspended',
        deleted: 'Closed',
      },
      page: {
        title: 'Billing & subscription',
        sub: "Manage your PetPro subscription, payment method, and history.",
        back: 'Back to cockpit',
        currentPlan: 'Current plan',
        tier: 'Tier',
        status: 'Status',
        paidThrough: 'Paid through',
        trialEnds: 'Trial ends',
        graceLeft: '{{days}} grace days remaining to complete payment',
        unknown: 'Subscription state unavailable.',
        payOptions: 'Payment options',
        payOptionsSub: 'Choose how to pay. Bank transfers are typically marked as paid within 1 business day.',
        stripeTitle: 'Online card (Stripe)',
        stripeSub: 'Pay by credit card — instant activation.',
        stripeComingSoon: 'Coming soon — please use bank transfer below for now.',
        stripePay: 'Pay with credit card',
        stripeRedirecting: 'Redirecting…',
        // Pricing-layer additions (h8i9j0k1l2m3)
        tierStarter: 'Starter',
        tierProfessional: 'Professional',
        tierHospital: 'Hospital',
        tierSolo: 'Solo',
        tierSmall: 'Small',
        tierPro: 'Pro',
        cycleMonthly: 'Monthly',
        cycleAnnual: 'Annual',
        saveAnnualBadge: 'Save ~17%',
        year: 'yr',
        notAvailable: 'Not available',
        promoLabel: 'Promo code (optional)',
        promoApply: 'Apply',
        promoChecking: 'Checking…',
        promoSavings: 'You save NT${{amount}} ({{net}} after discount)',
        promoInvalid: 'Code is invalid or not applicable.',
        promoRateLimit: 'Too many tries — wait a minute.',
        promoGenericError: 'Could not validate code.',
        pricingFetchFailed: 'Could not load tiers — please refresh.',
        manualTitle: 'Bank transfer / ATM',
        manualInstructions: 'Transfer to the account below. Include your business name in the memo, then notify PetPro support (LINE @petpro).',
        bankName: 'Bank',
        bankNameValue: 'First Commercial Bank (007)',
        bankAccount: 'Account',
        bankAccountValue: '23410089931',
        bankBeneficiary: 'Beneficiary',
        bankBeneficiaryValue: 'Camus Technologies, Ltd.',
        manualFootnote: "Support will mark your payment and renew your subscription within 1 business day. For urgent activation, call 02-XXXX-XXXX.",
        history: 'Payment history',
        historyHidden: 'Subscription is suspended — complete payment to see history.',
        noHistory: 'No payments on record yet.',
        colDate: 'Recorded',
        colPeriod: 'Period',
        colMethod: 'Method',
        colAmount: 'Amount',
      },
    },
  },
}
